export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <span className="font-heading text-xl text-background-50 mb-3 block">汗汗漫画</span>
            <p className="text-sm leading-relaxed">
              韩漫日漫国漫免费漫画全集分类平台，下拉式连续阅读模式，在线看漫画流畅不卡顿，尽享热门漫画大全。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">快速导航</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#features" onClick={(e) => { e.preventDefault(); document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">阅读体验</a></li>
              <li><a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">漫题索引</a></li>
              <li><a href="#carousel" onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">编辑精选</a></li>
              <li><a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">人气排行</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">漫画分类</h4>
            <ul className="space-y-2 text-sm">
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">韩漫精选</span></li>
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">日漫经典</span></li>
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">国漫专区</span></li>
              <li><span className="cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">恋爱热血悬疑奇幻</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-50/50">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; 2026 汗汗漫画网 - 韩漫日漫国漫免费漫画全集 | 下拉式连续阅读漫画大全
          </p>
          <p className="text-xs text-background-50/50">
            本站所有漫画内容均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}